export default __webpack_public_path__ + "static/media/Screenshot 2022-11-02 at 19.01.56.976f0b29.png";